import React, { useContext, useState } from "react";
import { openDB } from "idb";
import LeftPanel from "../components/LeftPanel";
import MasterMenu from "../components/MasterMenu";
import NewSeat from "./NewSeat";
import NewSection from "./NewSection";

import Context from "../context/context"
const Page5 = () => {
  const [isSeatOpen, setIsSeatOpen] = useState(false);
  const [isSectionOpen, setIsSectionOpen] = useState({ status: false, type: 'New' });
  const [isSeatModified, setIsSeatModified] = useState(null);
  const [isNewSeatAdded, setIsNewSeatAdded] = useState(null);
  const [newSectionCreated, setNewSectionCreated] = useState(null);
  const [sectionDragged, setSectionDragged] = useState(null);
  const context = useContext(Context)
  const [selectedValue, setSelectedValue] = useState({});
  const { isBulkUploadOpen, setIsBulkUploadOpen } = context
  const handleSeatOpen = () => {
    setIsSeatOpen(!isSeatOpen);
  };
  const handleSectionOpen = () => {
    setIsSectionOpen({ status: !isSectionOpen.status, type: 'New' });
  };
  const handleBulkUploadOpen = () => {
    setIsBulkUploadOpen(!isBulkUploadOpen);
  };

  const read = async (transactionname) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let objectStore = await db
      .transaction(`${transactionname}`, "readwrite")
      .objectStore(`${transactionname}`);
    return transactionname === "outlet"
      ? (await objectStore.getAll())[0]
      : objectStore.getAll();
  };

  const getNewSeatAdded = (data) => {
    setIsNewSeatAdded(data);
  };

  const getNewSectionCreated = (data) => {
    setNewSectionCreated(data);
  };

  return (
    <>
      <LeftPanel
        read={read}
        categoryDraggable={true}
        isCatogories={true}
        newSectionCreated={newSectionCreated}
        setNewSectionCreated={setNewSectionCreated}
        setSectionDragged={setSectionDragged}
        setIsSeatModified={setIsSeatModified}

        setIsSectionOpen={setIsSectionOpen}
        selectedValue={selectedValue}
        setSelectedValue={setSelectedValue}
      />
      <MasterMenu
        read={read}
        handleSeatOpen={handleSeatOpen}
        handleSectionOpen={handleSectionOpen}
        handleBulkUploadOpen={handleBulkUploadOpen}
        isNewSeatAdded={isNewSeatAdded}
        newSectionCreated={newSectionCreated}
        setNewSectionCreated={setNewSectionCreated}
        sectionDragged={sectionDragged}

        selectedValue={selectedValue} setSelectedValue={setSelectedValue}
        isSeatModified={isSeatModified} setIsSeatModified={setIsSeatModified}
      />
      {isSeatOpen && (
        <NewSeat
          type="New"
          read={read}
          close={handleSeatOpen}
          getNewSeatAdded={getNewSeatAdded}
          isNewSeatAdded={isNewSeatAdded}
          setIsNewSeatAdded={setIsNewSeatAdded}
        />
      )}
      {isSectionOpen?.status && (
        <NewSection
          type={isSectionOpen?.type}
          read={read}
          close={handleSectionOpen}
          getNewSectionCreated={getNewSectionCreated}
          newSectionCreated={newSectionCreated}
          setNewSectionCreated={setNewSectionCreated}

          order={selectedValue?.section_sort_order}
          UUID={selectedValue?.UUID}
          value={selectedValue?.section_name}
          id={selectedValue?.section_uuid}
        />
      )}
    </>
  );
};
export default Page5;
